<div class="card mb-5 chart-wrapper" [style.height]="resolvedHeight">
  <div class="card-header" style="border-bottom: none;" *ngIf="data?.showCardHeader !== false">
    <div class="card-title d-flex flex-column">
      <h4>{{ data.title | capitalCase }}</h4>
    </div>
  </div>
  <div
    class="card-body chart-body"
    [class.square-chart-body]="shouldUseSquarePlot"
    [style.--quad-square-plot-max-width]="shouldUseSquarePlot ? squarePlotMaxWidth : null">
    <div [id]="data.widgetId" class="chart-host"></div>
  </div>
</div>
